import React, { Component } from "react";
import ProjectsItem from "./ProjectsItem";

import mavisgate from "../img/projetos/mavisgate.png";
import barberapp from "../img/projetos/barberapp.png";
import foxshoes from "../img/projetos/foxshoes.png";
import amazingtrips from "../img/projetos/amazingtrips.png";
import brojohn from "../img/projetos/brojohn.png";
import monstermovies from "../img/projetos/monstermovies.png";
import moneyconverter from "../img/projetos/moneyconverter.png";
import lyricsfinderproject from "../img/projetos/lyrics.png";
import marvelsearchheroes from "../img/projetos/marvelsearchheroes.png";

export default class Projects extends Component {
  state = {
    projects: [
      {
        id: 1,
        link: "https://mavisgate.herokuapp.com",
        githublink: "https://github.com/danielferreiradf/mavisgate",
        img: `${mavisgate}`,
        title: "Mavisgate",
        description:
          "Project developed using the MERN Stack, MongoDB - Express - React - NodeJS. Web Browser RPG. "
      },
      {
        id: 2,
        link: "https://monstermovies.herokuapp.com",
        githublink: "https://github.com/danielferreiradf/monstermovies",
        img: `${monstermovies}`,
        title: "Monster Movies",
        description:
          "Project developed in React + Redux, using the Movies Database public API."
      },
      {
        id: 3,
        githublink: "https://github.com/danielferreiradf/baber_app_web",
        img: `${barberapp}`,
        title: "BarberApp",
        description:
          "A barber app which has the functionality of allowing customers to book appointments for a barber shop."
      },
      {
        id: 4,
        link: "https://marvelsearchheroes.netlify.com",
        githublink: "https://github.com/danielferreiradf/marvelsearchheroes",
        img: `${marvelsearchheroes}`,
        title: "Marvel Search Heroes",
        description:
          "Project developed in React, using the Marvel Comics public API."
      },
      {
        id: 5,
        githublink: "https://github.com/danielferreiradf/fox-shoes",
        img: `${foxshoes}`,
        title: "Fox Shoes",
        description:
          "A shoes store, built with React + Redux, to simulate a small e-commerce."
      },
      {
        id: 6,
        link: "https://danielferreiradf.github.io/moneyconverter",
        githublink: "https://github.com/danielferreiradf/moneyconverter",
        img: `${moneyconverter}`,
        title: "Money Converter",
        description:
          "Project developed in React, using the Foreign exchange rates API, currency converter application."
      },

      {
        id: 7,
        link: "https://lyricsfinderproject.netlify.com",
        githublink: "https://github.com/danielferreiradf/lyricsfinder",
        img: `${lyricsfinderproject}`,
        title: "Lyrics Finder",
        description:
          "Project developed in React + ContextAPI, using the Musixmatch Musics public API."
      },
      {
        id: 8,
        link: "https://danielferreiradf.github.io/amazingtripsproject",
        githublink: "https://github.com/danielferreiradf/amazingtripsproject",
        img: `${amazingtrips}`,
        title: "Amazing Trips",
        description:
          "Fictional project developed for the company Amazing Trips."
      },

      {
        id: 9,
        link: "https://bronjohnmotorcycles.netlify.com",
        githublink: "https://github.com/danielferreiradf",
        img: `${brojohn}`,
        title: "BRO & Jhon Motorcycles",
        description:
          "Fictional project developed for the company BRO & Jhon Motorcycles."
      }
    ]
  };
  render() {
    return (
      <section id="projects" className="projects col-padding">
        <div className="container">
          <h1 className="heading-1 mt-1 text-white">Projects</h1>
          <p className="heading-2">Some projects developed by me.</p>

          <div className="projects__panel">
            <ProjectsItem projectsItems={this.state.projects} />
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects.js